import { API_CONFIG } from '../config/api';

interface BiometricSearchResponse {
  is_match: boolean;
  score: number;
  user_id: number;
  threshold: number;
}

interface BiometricVerifyResponse {
  is_match: boolean;
  score: number;
  threshold: number;
}

const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
});

export const biometricService = {
  async searchFace(imageBase64: string): Promise<BiometricSearchResponse> {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.RECOGNITION_SEARCH}`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
          img_b64: imageBase64,
        }),
      });

      if (!response.ok) {
        throw new Error('Biometric search failed');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async verifyFace(userId: string, imageBase64: string): Promise<BiometricVerifyResponse> {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.RECOGNITION_VERIFY}`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
          user_id: userId,
          img_b64: imageBase64,
        }),
      });

      if (!response.ok) {
        throw new Error('Biometric verification failed');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },
}; 